import { Skeleton } from "@/components/ui/skeleton";

function PageShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-full bg-background px-4 pt-safe pb-6">
      <div className="mx-auto max-w-sm space-y-6">{children}</div>
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <PageShell>
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-24 w-full rounded-xl" />
      <div className="space-y-3">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-20 w-full rounded-xl" />
        <Skeleton className="h-20 w-full rounded-xl" />
      </div>
    </PageShell>
  );
}

export function ChildViewSkeleton() {
  return (
    <div className="min-h-full bg-background px-4 pt-safe pb-6">
      <div className="mx-auto max-w-sm space-y-6">
        <div className="flex items-center justify-between">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-7 w-28 rounded-full" />
        </div>
        <div className="flex flex-col items-center gap-2">
          <Skeleton className="h-12 w-12 rounded-full" />
          <Skeleton className="h-7 w-32" />
          <Skeleton className="h-4 w-40" />
        </div>
        <div className="space-y-3">
          <Skeleton className="h-5 w-24" />
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}

export function ChildDayViewSkeleton() {
  return (
    <div className="min-h-full bg-background px-4 pt-safe pb-6">
      <div className="mx-auto max-w-sm space-y-6">
        <div className="flex items-center justify-between">
          <Skeleton className="h-6 w-28 rounded-full" />
        </div>
        <div className="flex flex-col items-center gap-2">
          <Skeleton className="h-12 w-12 rounded-full" />
          <Skeleton className="h-8 w-40" />
          <Skeleton className="h-4 w-32" />
        </div>
        <div className="rounded-2xl bg-muted/60 p-4 space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-3 w-full rounded-full" />
          <Skeleton className="h-4 w-32 mx-auto" />
        </div>
        <div className="space-y-3 rounded-2xl bg-primary/5 p-4">
          <Skeleton className="h-5 w-44" />
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}

export function SettingsSkeleton() {
  return (
    <PageShell>
      <div className="rounded-xl border p-4 space-y-3">
        <Skeleton className="h-5 w-16" />
        <Skeleton className="h-14 w-full rounded-lg" />
        <Skeleton className="h-14 w-full rounded-lg" />
      </div>
      <Skeleton className="h-px w-full" />
      <div className="rounded-xl border p-4 space-y-3">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-14 w-full rounded-lg" />
        <Skeleton className="h-14 w-full rounded-lg" />
      </div>
    </PageShell>
  );
}

export function CustodySkeleton() {
  return (
    <PageShell>
      <Skeleton className="h-4 w-64" />
      <div className="space-y-2">
        <Skeleton className="h-10 w-full rounded-lg" />
        <Skeleton className="h-10 w-full rounded-lg" />
      </div>
      <div className="space-y-2">
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full rounded-lg" />
        ))}
      </div>
    </PageShell>
  );
}

export function ExchangeSkeleton() {
  return (
    <PageShell>
      <div className="flex gap-2">
        <Skeleton className="h-10 w-28 rounded-full" />
        <Skeleton className="h-10 w-28 rounded-full" />
      </div>
      <Skeleton className="h-32 w-full rounded-xl" />
    </PageShell>
  );
}
